"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
function getSensitivityOptions() {
    return [
        { value: 'CompanyConfidential', text: owa_options_strings_1.default.options_inboxRules_companyConfidential },
        { value: 'Normal', text: owa_options_strings_1.default.options_inboxRules_normal },
        { value: 'Personal', text: owa_options_strings_1.default.options_inboxRules_personal },
        { value: 'Private', text: owa_options_strings_1.default.options_inboxRules_private },
    ];
}
exports.default = getSensitivityOptions;
//# sourceMappingURL=getSensitivityOptions.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/helpers/getSensitivityOptions.js
// module id = 5201
// module chunks = 2